<ng-container *transloco="let t; prefix: 'profile'">
  <app-panel-body>
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
        <div class="profile-edit-form">
          @if (showManagingOwnAccountNotice()) {
            <app-inline-alert
              severity="info"
              [message]="managingOwnAccountMessage()"
              class="mb-4"
            />
          }

          <!-- Profile Photo -->
          <div class="form-group">
            <label>{{ t('profile-photo') }}</label>
            <div class="profile-photo-upload">
              <div class="profile-photo-preview">
                @if (showProfilePhoto()) {
                  <img
                    [src]="user()!.profilePhotoUrl"
                    [alt]="user()?.displayName"
                    (error)="onProfilePhotoError()"
                  >
                } @else {
                  <fa-icon [icon]="['far', 'user']" />
                }
              </div>
              @if (!showPhotoUpload()) {
                <div class="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
                  <button
                    type="button"
                    class="btn-outline btn-no-grow"
                    [disabled]="uploadingPhoto() || removingPhoto()"
                    (click)="startPhotoUpload()"
                  >
                    {{ t('change-photo') }}
                  </button>
                  @if (user()?.hasProfilePhoto) {
                    <app-button
                      variant="outline"
                      [disabled]="uploadingPhoto() || removingPhoto()"
                      [loading]="removingPhoto()"
                      (clicked)="removePhoto()"
                    >
                      {{ t('remove-photo') }}
                    </app-button>
                  }
                </div>
              }
            </div>

            @if (photoUploadError()) {
              <app-inline-alert severity="danger" [message]="photoUploadError()!" class="mt-3" />
            }

            @if (showPhotoUpload()) {
              <div class="mt-4">
                <app-image-crop-upload
                  [aspectRatio]="1"
                  [maxWidth]="256"
                  [maxHeight]="256"
                  outputMime="image/jpeg"
                  [quality]="0.8"
                  (imageReady)="onPhotoReady($event)"
                  (cancelled)="cancelPhotoUpload()"
                />
              </div>
            }
          </div>

          <!-- Name (read-only — edit in My Info) -->
          <div class="form-group">
            <label>{{ t('name') }}</label>
            <p class="profile-readonly-value m-0 text-primary-text" id="profile-display-name">
              {{ user()?.displayName }}
            </p>
            <button
              type="button"
              class="text-link mt-2 underline bg-transparent border-0 p-0 cursor-pointer"
              (click)="openMyInfo()"
            >
              {{ t('edit-name-in-my-info') }}
            </button>
          </div>

          <!-- Language -->
          <div class="form-group">
            <label for="profile-language-select">{{ t('language') }}</label>
            <select
              id="profile-language-select"
              class="mt-1 w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm text-primary-text"
              [ngModel]="language()"
              (ngModelChange)="updateLanguage($event)"
            >
              <option [ngValue]="'en'">English</option>
              <option [ngValue]="'es'">Español</option>
            </select>
            @if (activeLanguageSaveStatus(); as status) {
              @if (languageSaveStatusLabel()) {
                <app-field-save-status
                  class="mt-2"
                  [status]="status"
                  [message]="languageSaveStatusLabel()!"
                />
              }
            }
          </div>

          <!-- Accessibility Settings -->
          <div class="form-group">
            <label>{{ t('accessibility') }}</label>
            <app-accessibility-settings />
          </div>

          <!-- Account identity -->
          <div class="form-group">
            <label>{{ t('account-identity') }}</label>
            <div class="flex flex-col gap-2">
              <app-button variant="outline" (clicked)="openChangeEmail()">
                {{ t('change-email-action') }}
              </app-button>
              <app-button variant="outline" (clicked)="openChangePassword()">
                {{ t('change-password-action') }}
              </app-button>
            </div>
          </div>
        </div>
      </app-content-container>
    </div>
  </app-panel-body>
</ng-container>
